import { render, staticRenderFns } from "./LegalRepresentation.vue?vue&type=template&id=ebb7a808&scoped=true&"
import script from "./LegalRepresentation.vue?vue&type=script&lang=js&"
export * from "./LegalRepresentation.vue?vue&type=script&lang=js&"
import style0 from "./LegalRepresentation.vue?vue&type=style&index=0&id=ebb7a808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb7a808",
  null
  
)

export default component.exports